export default "__VITE_ASSET__DrRBXcSP__"